import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const ColumnsReferencingFieldQueryGql: DocumentNode = gql`
query ColumnsReferencingFieldQuery($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: { id: $fieldId }) {
    __typename
    ... on ColumnField {
      columnsConnection(first: $first, offset: $offset, orderBy: { field: ID, direction: ASC }) {
        totalCount
        nodes {
          id
          name
          table {
            __typename
            id
            name
          }
        }
      }
    }
  }
}
`;
